import api from "../api/CustomerApi";
import {
  setCustomerToken,
  clearCustomerToken,
  getCustomerToken,
} from "../utils/CustomerAuth";
export const CustomerAuthService = {
  // ✅ Step 1: Send OTP for registration (with password)
  sendRegisterOtp: async ({ name, email, password, password_confirmation }) => {
    const res = await api.post("/customer/register/send-otp", {
      name,
      email,
      password,
      password_confirmation,
    });
    return res?.data;
  },
  // ✅ Step 2: Verify OTP and complete registration
  verifyRegisterOtp: async ({ email, otp }) => {
    const res = await api.post("/customer/register/verify-otp", {
      email,
      otp,
    });
    const token = res?.data?.token;
    if (token) {
      setCustomerToken(token);
      window.dispatchEvent(new Event("customer_logged_in"));
    }
    return res?.data;
  },
  // ✅ Step 1: Send OTP for login (with password verification)
  // sendLoginOtp: async ({ email, password }) => {
  //   const res = await api.post("/customer/login/send-otp", { email, password });
  //   return res?.data;
  // },
  // // ✅ Step 2: Verify OTP and complete login
  // verifyLoginOtp: async ({ email, otp }) => {
  //   const res = await api.post("/customer/login/verify-otp", { email, otp });
  //   const token = res?.data?.token;
  //   if (token) {
  //     setCustomerToken(token);
  //     window.dispatchEvent(new Event("customer_logged_in"));
  //   }
  //   return res?.data;
  // },

  // ✅ Direct login without OTP
  login: async ({ email, password }) => {
    const res = await api.post("/customer/login", {
      email,
      password,
    });

    const token = res?.data?.token;

    if (token) {
      setCustomerToken(token);
      window.dispatchEvent(new Event("customer_logged_in"));
      window.dispatchEvent(new Event("customer_auth_changed"));
    }

    return res?.data;
  },
  me: async () => {
    const token = getCustomerToken();
    if (!token) return null;
    const res = await api.get("/customer/me");
    return res?.data;
  },

  logout: async () => {
    try {
      await api.post("/customer/logout");
    } finally {
      clearCustomerToken();
      window.dispatchEvent(new Event("customer_logged_out"));
    }
  },
  forgotPassword: async (email) => {
    const res = await api.post("/customer/forgot-password", { email });
    return res?.data;
  },
  resetPassword: async ({ email, token, password, password_confirmation }) => {
    const res = await api.post("/customer/reset-password", {
      email,
      token,
      password,
      password_confirmation,
    });
    return res?.data;
  },
  /**
   * Update profile: name and/or password.
   * Email is NOT changeable — do not pass it.
   *
   * @param {object} payload
   * @param {string} [payload.name]                  - new display name
   * @param {string} [payload.current_password]      - required when changing password
   * @param {string} [payload.password]              - new password (min 6)
   * @param {string} [payload.password_confirmation] - must match password
   */
  updateProfile: async (payload) => {
    const res = await api.put("/customer/profile", payload);
    return res?.data;
  },
};
export default CustomerAuthService;